import { combineReducers } from 'redux';
import key from './key/keyReducer';

export default combineReducers({
	key,
});
